module.exports = __webpack_public_path__ + "img/gift3.24ad2d02.png";